export default __webpack_public_path__ + "static/rsz_wojzycz-7b6afc346984945e7e2a908b894b2d91.jpg";